import { shallowEqual, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import DataTable from "./DataTable";
import TableHeader from "./TableHeader";
import ContainerLoadingwithBlurEffect from "../../../../Common/Loading Animations/ContainerLoadingWithBlurEffect";
import { memo } from "react";
import { useMemo } from "react";
const TableContainer = memo(
  ({
    videoSettings,
    setVideoSettings,
    playing,
    setPlaying,
    handleZoomIn,
    handleZoomOut,
    currentVideoIndex,
    setCurrentVideoIndex,
  }) => {
    const selectedState = useSelector(
      (state) => ({
        isTableLoading: state?.VideoLibraryDataTable?.isTableLoading,
        errors: state?.VideoLibraryDataTable?.errors,
        isTableEditable: state?.VideoLibraryDataTable?.isTableEditable,
        loading: state?.VideoLibraryDataTable?.loading,
        tableSeasonInfo: state?.VideoLibraryDataTable?.tableSeasonInfo,
      }),
      shallowEqual
    );
    const { isDrawerOpen } = useSelector(
      (state) => state?.schoolAdminDashboardInformation
    );

    const memoizedState = useMemo(() => selectedState, [selectedState]);
    const topValue = videoSettings.fullHeight ? "120%" : "180%";
    return (
      <div
        className="bottom position-relative"
        // style={{ top: isDrawerOpen ? topValue : "auto" }}
      >
        {memoizedState.isTableLoading ? (
          <div className="d-flex-center data-table-loading-container white-shadow-box">
            <div className="loading-background rounded-circle bg-white shadow position-absolute p-2 d-flex justify-content-center align-items-center">
              <CircularProgress
                className="rounded-circle"
                color="success"
                sx={{ fontSize: 10, color: "#002244" }}
                disableShrink
              />
            </div>
          </div>
        ) : (
          <>
            {!memoizedState.errors?.tableFetchError ? (
              <div className={`mg-10`}>
                <TableHeader
                  handleZoomOut={handleZoomOut}
                  handleZoomIn={handleZoomIn}
                  videoSettings={videoSettings}
                  setVideoSettings={setVideoSettings}
                />
                <DataTable
                  videoSettings={videoSettings}
                  playing={playing}
                  setPlaying={setPlaying}
                  memoizedState={memoizedState}
                  currentVideoIndex={currentVideoIndex}
                  setCurrentVideoIndex={setCurrentVideoIndex}
                />
                {memoizedState.loading && <ContainerLoadingwithBlurEffect />}
              </div>
            ) : (
              <div className="white-shadow-box pd-20 mg-10">
                <p className="red fs-18 semi-bold text-center pd-10">
                  {memoizedState.errors?.tableFetchError}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
);

export default TableContainer;
